import axios from "axios";

export const instance = axios.create({
  timeout: 10000
});

export const getQuizSessions = () => {
  return instance({
    method: "get",
    url: "/work/api/quiz/session",
    headers: {
      'Accept': 'application/json'
    }
  });
};

export const getSessionAnswers = (id) => {
  return instance({
    method: "get",
    url: `/work/api/quiz/session/${id}`,
    headers: {
      'Accept': 'application/json'
    }
  });
};

export default {
  getQuizSessions,
  getSessionAnswers
}
